export default function parseSubviewModel(subviewName) {
    return subviewName.split('$')[0];
}